/**
 * Outside-carrier pseudo-driver helpers.
 *
 * Legacy CMS lets an outside-carrier move (no GWI equipment) carry the carrier
 * itself in the driver field as a pseudo-unit: the carrier's SCAC, or — when the
 * SCAC is blank — the first 6 alphanumeric characters of the carrier name.
 *
 * Perl origin:
 *   $scac = $truckerscac;
 *   if ($scac eq '') { $scac = $truckername; $scac =~ s/[^a-z0-9]//gi; $scac = substr($scac,0,6); }
 */

/**
 * Dispatchers for which the Carrier field is editable (an outside-carrier /
 * non-GWI move). When the dispatcher is one of these AND a carrier is chosen,
 * the driver field gains a selectable pseudo-driver derived from the carrier.
 */
export const CARRIER_DISPATCHERS = new Set([
  'outsidecarrier',
  'brokerage',
  'customerpickup',
  'dallasdomestic',
  'highway',
]);

/**
 * Derive the pseudo-driver code from a carrier's SCAC/name. Prefers the SCAC;
 * falls back to the first 6 alphanumeric chars of the name (case preserved).
 */
export function deriveOutsideCarrierDriver(
  scac: string | null | undefined,
  name: string | null | undefined,
): string {
  return (
    (scac || '').trim() ||
    (name || '').replace(/[^a-z0-9]/gi, '').substring(0, 6)
  );
}

/**
 * The pseudo-driver code for the given dispatcher + carrier, or '' when the
 * dispatcher isn't an outside carrier or no carrier is chosen (both scac and
 * name blank → derive returns '').
 */
export function outsideCarrierDriverFor(
  dispatcher: string | null | undefined,
  scac: string | null | undefined,
  name: string | null | undefined,
): string {
  return CARRIER_DISPATCHERS.has(String(dispatcher || ''))
    ? deriveOutsideCarrierDriver(scac, name)
    : '';
}
